// src/constants/partners.js
export const PARTNER_BRANDS = [
  "vivo", "haier", "whirlpool", "oppo", "xiaomi", "realme", "tcl", "lloyd",
  "iqoo", "amstrad", "tecno", "infinix", "redmi", "ifb", "vzy", "wobble",
  "acer", "perrel", "black & decker", "ifb ref", "godrej", "voltas",
  "voltbek", "oneplus", "indkal", "walton", "ai+", "nothing", "hp"
];

const PARTNER_BRANDS_SET = new Set(PARTNER_BRANDS.map((b) => b.toLowerCase()));

export const isValidPartnerSlug = (slug) => {
  if (!slug || typeof slug !== "string") return false;
  return PARTNER_BRANDS_SET.has(slug.toLowerCase());
};